module.exports = __webpack_public_path__ + "static/media/sensable_34.085df859.gif";